import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IRequestAuthorizationTokenEnrollmentResponse {
  cookie: string;
}

export interface IRequestAuthorizationTokenEnrollmentOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (opts: IRequestAuthorizationTokenEnrollmentOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["enrollment", "authorize"]);

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(uri)) : false,
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };

  if (!apiKey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function requestAuthorizationTokenEnrollment(
  opts: IRequestAuthorizationTokenEnrollmentOpts,
): Promise<JsonQuery<IResultstash<IRequestAuthorizationTokenEnrollmentResponse>>> {
  return fetchJsonQuery<IResultstash<IRequestAuthorizationTokenEnrollmentResponse>>(createRequest(opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default requestAuthorizationTokenEnrollment;
